import { IDemands } from 'types/demands';
import api from '../services/config/api';

export const editDemand = (
  id: string,
  data: Omit<IDemands, 'areaInterna'> & { areaInterna: string },
) => api.put<IDemands>(`/solicitacao/${id}`, data);

// export const editClientDemand = (
//   id: string,
//   data: Omit<IRequestDemands, 'serviceType'> & { serviceType: { id: number } },
// ) => api.put<IDemands>(`/solicitacao/documentos-consultas/${id}`, data);

export const editClientDemand = (id: string, data: FormData) =>
  api.put(`/solicitacao/documentos-consultas/${id}`, data);
